import { require200Status } from "../../utils/response.js";
import { transformWithSpec } from "../../../utils/response.js";
function bankAccountEndpoints(builder) {
  return {
    /**
     * @deprecated use createFundingProfile instead
     */
    addBankAccount: builder.mutation({
      query: (body) => ({
        url: `/member/bank-account/create`,
        validateStatus: require200Status,
        method: "POST",
        body
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  bankAccountEndpoints as default
};
